export default "__VITE_ASSET__h_xy54Mj__"